import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_product_group_customers",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content p-5" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "card-body pt-5 pb-0" }
const _hoisted_7 = { class: "row g-3 align-items-center" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, _toDisplayString(`${_ctx.groupName} – ${_ctx.$t('message.CUSTOMERS')}`), 1),
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchKey,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKey = $event)),
                clearable: "",
                placeholder: _ctx.$t('message.ENTER_KEY_TO_SEARCH'),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.getCustomers(1)), ["enter"])),
                onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCustomers(1)))
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCustomers(1)))
              }, _toDisplayString(_ctx.$t('message.SEARCH')), 1)
            ])
          ])
        ]),
        _createVNode(_component_Table, {
          columns: _ctx.columns,
          rows: _ctx.customers,
          pagination: _ctx.pagination,
          padding: 5,
          loading: _ctx.loader,
          onHandleCurrentChange: _ctx.getCustomers
        }, {
          "cell-name": _withCtx(({ row: item }) => [
            (_ctx.$can('view_customers_list'))
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.openCustomer(item)), ["prevent"])
                }, _toDisplayString(item.name), 9, ["onClick"]))
              : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(item.name), 1))
          ]),
          "cell-economic_number": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.economic_number ? item.economic_number : 'N/A'), 1)
          ]),
          _: 1
        }, 8, ["columns", "rows", "pagination", "loading", "onHandleCurrentChange"])
      ])
    ])
  ]))
}